import { createElement } from 'react';
import PropTypes from 'prop-types';
import uuid from 'react-uuid';

import ColumnDefault from './ColumnDefault';
import ColumnPoints from './ColumnPoints';
import ColumnVendor from './ColumnVendor';
import { Wrapper } from './styles';

const columnReturn = string => string.split('-')[0];

const componentResolver = type => {
  switch (type) {
    case 'default-cell':
      return ColumnDefault;
    case 'feature-cell':
      return ColumnDefault;
    case 'points-cell':
      return ColumnPoints;
    case 'vendors-cell':
      return ColumnVendor;
    default:
      return ColumnDefault;
  }
};

const ChartRowLayout = ({
  componentType,
  componentStyle = null,
  columnCount = '4',
  data = null,
  className = '',
  isHeader = false,
  isSticky = false,
  headers = '',
  activeColumnIdx = null,
  firstSelectableCell = null,
  setActiveColumn = null,
  percentage = false,
}) => {
  // * Null check for data
  if (!componentType) return false;

  const columns = columnReturn(columnCount);
  const type = componentType.split(' ').join('-').toLowerCase();
  const component = componentResolver(type);

  return (
    <Wrapper
      className={`${type} ${componentStyle} ${className}`}
      columnCount={columns}
      role="row"
    >
      {component === ColumnVendor ? (
        <ColumnVendor
          dataItem={data}
          headers={headers}
          columnCount={columnCount}
        />
      ) : (
        data.map((dataItem, index) => {
          let isNotActive = '';

          if (className.includes('selectable-card chart')) {
            isNotActive =
              (dataItem.selectable && !activeColumnIdx) ||
              index < firstSelectableCell ||
              (activeColumnIdx >= firstSelectableCell &&
                activeColumnIdx === index)
                ? ''
                : 'is-not-active';
          }

          return createElement(component, {
            dataItem,
            index,
            key: uuid(),
            componentType,
            componentStyle,
            type,
            columnCount,
            className,
            isHeader,
            isSticky,
            headers,
            activeColumnIdx,
            firstSelectableCell,
            setActiveColumn,
            isNotActive,
            percentage,
          });
        })
      )}
    </Wrapper>
  );
};

ChartRowLayout.propTypes = {
  componentType: PropTypes.string.isRequired,
  componentStyle: PropTypes.string,
  columnCount: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape()),
  className: PropTypes.string,
  isHeader: PropTypes.bool,
  isSticky: PropTypes.bool,
  headers: PropTypes.string,
  activeColumnIdx: PropTypes.number,
  firstSelectableCell: PropTypes.number,
  setActiveColumn: PropTypes.func,
  percentage: PropTypes.bool,
};

export default ChartRowLayout;
